let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jul2W")).then(() => parcelRequire('c6QDa'));